/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppEmbeddedSignupRetryProvisioning } from '../../axios/whatsAppEmbeddedSignupRetryProvisioning'
import type {
	WhatsAppEmbeddedSignupRetryProvisioningError,
	WhatsAppEmbeddedSignupRetryProvisioningPathParams,
	WhatsAppEmbeddedSignupRetryProvisioningResponse,
} from '../../types/WhatsAppEmbeddedSignupRetryProvisioning'

export const whatsAppEmbeddedSignupRetryProvisioningMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/signup/retry-provisioning' }] as const

export type WhatsAppEmbeddedSignupRetryProvisioningMutationKey = ReturnType<
	typeof whatsAppEmbeddedSignupRetryProvisioningMutationKey
>

export type WhatsAppEmbeddedSignupRetryProvisioningVariables = {
	organisationId: WhatsAppEmbeddedSignupRetryProvisioningPathParams['organisationId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::retryProvisioning */
export function useWhatsAppEmbeddedSignupRetryProvisioning<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppEmbeddedSignupRetryProvisioningResponse,
		AxiosError<WhatsAppEmbeddedSignupRetryProvisioningError>,
		WhatsAppEmbeddedSignupRetryProvisioningVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppEmbeddedSignupRetryProvisioningMutationKey(),
		mutationFn: ({ organisationId }: WhatsAppEmbeddedSignupRetryProvisioningVariables) =>
			whatsAppEmbeddedSignupRetryProvisioning(organisationId, config).then(res => res.data),
		...options,
	})
}
